module.exports = __webpack_public_path__ + "img/Energetic Driver.b4109237.svg";